import { render } from "./NotFoundError.vue?vue&type=template&id=4939b1a5"
const script = {}

import exportComponent from "/codebuild/output/src3688271429/src/tbs-actressProject-judge-liff-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__